import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabase';

interface TestMetaTagsProps {
  testData?: any;
}

export const TestMetaTags: React.FC<TestMetaTagsProps> = ({ testData }) => {
  const { testId } = useParams();
  const [test, setTest] = useState(testData);

  useEffect(() => {
    if (!test && testId && !testId.startsWith('custom_')) {
      const fetchTestData = async () => {
        try {
          const { data, error } = await supabase
            .from('exams')
            .select('*')
            .eq('id', Number(testId))
            .single();

          if (!error && data) {
            setTest({
              id: data.id,
              name: data.Name,
              exam: data.exam,
              duration: data.Duration,
              questionsCount: data.Questions.split(',').length,
              totalMarks: data.Questions.split(',').length * 4,
            });
          }
        } catch (err) {
          console.error('Error fetching test meta data:', err);
        }
      };

      fetchTestData();
    }
  }, [testId, test]);

  if (!test) return null;

  const title = `${test.name} - ${test.exam} Mock Test | TestSeries`;
  const description = `Take the ${test.name} mock test for ${test.exam}. ${test.questionsCount} questions, ${test.duration} minutes, ${test.totalMarks} marks. Practice and improve your exam preparation.`;
  const url = `https://testseries.world/test/${testId}/instructions`;
  const image = 'https://i.imgur.com/g2R5r3h.png';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};